const formatSortIcon = (sort, field) => {
  if (sort?.field === field) {
    return sort?.type === 'ASC' ? 'BsArrowUp' : 'BsArrowDown'
  }
}

const formatSortType = (sort, field) => {
  if (sort?.field === field) {
    return sort?.type === 'ASC' ? 'DESC' : 'ASC'
  } else {
    return 'ASC'
  }
}

export const sortOptions = (sort, setSort) => [
  {
    value: 'Código',
    iconRight: formatSortIcon(sort, 'YEARLY_ID'),
    width: '125px',
    onClick: () => setSort({ field: 'YEARLY_ID', type: formatSortType(sort, 'YEARLY_ID') })
  },
  {
    value: 'Responsável',
    iconRight: formatSortIcon(sort, 'USER_NAME'),
    onClick: () => setSort({ field: 'USER_NAME', type: formatSortType(sort, 'USER_NAME') })
  },
  {
    value: 'Destino',
    iconRight: formatSortIcon(sort, 'PLACE_NAME'),
    onClick: () => setSort({ field: 'PLACE_NAME', type: formatSortType(sort, 'PLACE_NAME') })
  },
  {
    value: 'Agendamento',
    iconRight: formatSortIcon(sort, 'SCHEDULING'),
    onClick: () => setSort({ field: 'SCHEDULING', type: formatSortType(sort, 'SCHEDULING') })
  },
  {
    value: 'Conclusão',
    iconRight: formatSortIcon(sort, 'END_DATE'),
    onClick: () => setSort({ field: 'END_DATE', type: formatSortType(sort, 'END_DATE') })
  },
  {
    value: 'SLA',
    iconRight: formatSortIcon(sort, 'SLA_EXPIRES_AT'),
    onClick: () => setSort({ field: 'SLA_EXPIRES_AT', type: formatSortType(sort, 'SLA_EXPIRES_AT') })
  },
  {
    value: 'Status',
    iconRight: formatSortIcon(sort, 'STATUS_ID'),
    onClick: () => setSort({ field: 'STATUS_ID', type: formatSortType(sort, 'STATUS_ID') })
  },
  {
    value: 'Prioridade',
    iconRight: formatSortIcon(sort, 'PRIORITY_ID'),
    onClick: () => setSort({ field: 'PRIORITY_ID', type: formatSortType(sort, 'PRIORITY_ID') })
  },
  {
    value: 'Tag',
    iconRight: formatSortIcon(sort, 'TAG_NAME'),
    onClick: () => setSort({ field: 'TAG_NAME', type: formatSortType(sort, 'TAG_NAME') })
  }
]
